// Packages
import { Component, h, Host, Prop } from "@stencil/core";

// Utils
import { buildColorClasses } from "@utils/theme";

// Types
import { TThemeColors } from "../../interface";

/**
 * `fx-text` wraps arbitrary content and applies a theme text color without
 * changing the content's inline-level layout. The base part accepts flow
 * content while using `display: contents` in the theme.
 *
 * @slot - The content to color.
 *
 * @part base - The flow-content wrapper around the default slot.
 */
// `styleUrl` is intentionally omitted (no internal styles per AGENTS.md).
@Component({
  tag: "fx-text",
  shadow: true,
})
export class FxText {
  /**
   * @prop - The color theme applied to the text. Reflects to `data-color`.
   */
  @Prop()
  color?: TThemeColors;

  render() {
    const { color } = this;

    return (
      <Host class={buildColorClasses(color)} data-color={color}>
        <div part="base">
          <slot />
        </div>
      </Host>
    );
  }
}
